module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00066"
    }
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "id": "ILLUSTRATIONS"
    }
  }), _vm._v("LIST OF ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0002"
    }
  }, [_vm._v("1. THE QUAKER CITY IN A STORM—FRONTPIECE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0002"
    }
  }, [_vm._v("2. ILLUMINATED TITLE-PAGE-THE PILGRIM’S VISION")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0007#p028"
    }
  }, [_vm._v("3. “I ‘LL PAY YOU IN PARIS\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0007#p030"
    }
  }, [_vm._v("4. THE START")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0008#p034"
    }
  }, [_vm._v("5. “GOOD MORNING, SIR\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0008#p036"
    }
  }, [_vm._v("6. THE OLD PIRATE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0009#p042"
    }
  }, [_vm._v("7. DANCING UNDER DIFFICULTIES")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0009#p044"
    }
  }, [_vm._v("8. THE MOCK TRIAL")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0010#p049"
    }
  }, [_vm._v("9. “LAND, HO!”")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0010#p052"
    }
  }, [_vm._v("10. THE CAPOTE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0010#p053"
    }
  }, [_vm._v("11. RUIN AND DESOLATION")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0011#p057"
    }
  }, [_vm._v("12. PORT OF HORTA, FAYAL")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0011#p059"
    }
  }, [_vm._v("13. “SEKKI-YAH\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0012#p064"
    }
  }, [_vm._v("14. BEAUTIFUL STRANGER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0012#p064a"
    }
  }, [_vm._v("15. ROCK OF GIBRALTAR")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0012#p067"
    }
  }, [_vm._v("16. “QUEEN’S CHAIR\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0012#p070"
    }
  }, [_vm._v("17. THE ORACLE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0012#p071"
    }
  }, [_vm._v("18. THE INTERROGATION POINT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0012#p072"
    }
  }, [_vm._v("19. GARRISON AT MALABAT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0012#p074"
    }
  }, [_vm._v("20. ENTERTAINING AN ANGEL")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0013#p077"
    }
  }, [_vm._v("21. VIEW OF A STREET IN TANGIER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0013#p081"
    }
  }, [_vm._v("22. CHANGE FOR A NAPOLEON")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0014#p088"
    }
  }, [_vm._v("23. THE CONSUL’S FAMILY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0015#p091"
    }
  }, [_vm._v("24. “POET LARIAT\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0015#p095"
    }
  }, [_vm._v("25. FIRST SUPPER IN FRANCE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0015#p096"
    }
  }, [_vm._v("26. PAINTING")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0016#p099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.  RINGING FOR SOAP")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0016#p100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.  “WINE, SIR!”")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0016#p101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.  THE PILGRIM")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0016#p103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.  THE PRISONER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0017#p106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.  HOMELESS FRANCE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0017#p108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.  RAILROAD OFFICIAL IN FRANCE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0017#p109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33.  “FIVE MINUTES FOR REFRESHMENTS”—AMERICA")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0017#p110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34.  “THIRTY MINUTES FOR DINNER”—FRANCE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0017#p111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35.  THE OLD TRAVELLER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0017#p115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36.  A DECIDED SHAVE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0017#p117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37.  A GAS-TLY SUBSTITUTE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0018#p119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38.  THE THREE GUIDES")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0018#p122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39.  “ZE SILK MAGAZIN\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0018#p124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40.  RETURN IN WAR PAINT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0018#p126a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41.  NAPOLEON III")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0018#p126b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42.  ABDUL AZIZ")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0019#p132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43.  THE MORGUE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0019#p135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44.  WE TOOK A WALK")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0019#p136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45.  THE CAN-CAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0020#p141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46.  GRAVES OF ABELARD AND HELOISE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0020#p142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47.  A PAIR OF CANONS OF 13TH CENTURY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0020#p144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48.  THE PRIVATE MARRIAGE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0020#p148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49.  AMERICAN DRINKS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0020#p150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50.  ROYAL HONORS TO A YANKEE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0020#p151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51.  THE GRISETTE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0021#p154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52.  FOUNTAIN AT VERSAILLES")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0022#p161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53.  WOMEN OF GENOA")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0022#p163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54.  PETRIFIED LACKEY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0022#p164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55.  PRIEST AND FRIAR")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0022#p168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56.  STATUE OF COLUMBUS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0022#p169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57.  GRAVES OF SIXTY THOUSAND")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0023#p172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58.  ROOF AND SPIRES OF CATHEDRAL AT MILAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0023#p173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59.  CENTRAL DOOR OF CATHEDRAL AT MILAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0023#p174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60.  INTERIOR OF CATHEDRAL AT MILAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0023#p176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61.  BOYHOOD EXPERIENCE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0023#p179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62.  TREASURES OF THE CATHEDRAL")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0023#p181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63.  CATHEDRAL AT MILAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0024#p184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64.  LA SCALA THEATRE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0024#p191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65.  COPYING FROM OLD MASTERS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0024#p194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66.  FACIAL EXPRESSION")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0024#p196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67.  TILE ECHO")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0024#p197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68.  NOTE BOOK")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0024#p198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69.  A KISS FOR A FRANC")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0025#p200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70.  THE FUMIGATION")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0025#p202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71.  LAKE COMO")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0025#p204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72.  GARDEN, LAKE COMO")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0026#p207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73 SOCIAL DRIVER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0026#p208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74 WAYSIDE SHRINE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0026#p209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75 PEACE AND HAPPINESS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0026#p210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76 CASTLE OF COUNT LUIGI")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0026#p215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77 THE WICKED BROTHER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0027#p220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78 DISGUSTED GONDOLIER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0027#p226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79 CATHEDRAL OF ST. MARK")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0028#p229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80 THE PEG")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0028#p230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81 “GOOD-BY\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0028#p234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82 M’SIEUR GOR-R-DONG")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0028#p236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83 MONUMENT TO THE DOOR")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0028#p238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84 ST. MARK, MATHEW, JEROME BY THE OLD MASTERS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0028#p239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87 ST. SEBASTIAN, AND ST. UNKNOWN BY THE OLD MASTERS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0028#p241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89 RIALTO BRIDGE AND BRIDGE OF SIGHS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0029#p245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91 FLORENCE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0029#p246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92 THE PENSIONER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0029#p248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93 “I WANT TO GO HOME\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0029#p250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94 THE LEANING TOWER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0029#p250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95 THE CONTRAST")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0030#p263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96 ITALIAN PASTIMES")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0030#p264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97 INCENDIARY DOCUMENT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0031#p267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98 A ROMAN OF 1869")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0031#p276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99 MAMERTINE PRISON")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0031#p278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100 OLD ROMAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0031#p281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101 COLISEUM OF ANCIENT ROME")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0032#p285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102 DID NOT COMPLAIN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0032#p286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103 HUMBOLDT HOUSE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0032#p288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104 DAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0032#p289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105 BRONZE STATUE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0032#p291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106 PENMANSHIP")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0032#p293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107 ON A BUST")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0033#p299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108 VAULTS OF THE CONVENT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0033#p302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109 DRIED CONVENT FRUITS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0033#p303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110 AT THE STORE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0033#p304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111 AT HOME")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0034#p309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112 SOOTHING THE PILGRIMS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0034#p313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113 ASCENT OF MT VESUVIUS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0035#p316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114 BAY OF NAPLES")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0035#p319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115 THE MUSTANG")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0035#p320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116 ISLAND OF CAPRI")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0035#p321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117 BLUE GROTTO")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0035#p323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118 VESUVIUS AND BAY of NAPLES")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0035#p325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119 THE DESCENT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0036#p328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120 RUINS, POMPEII")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0036#p330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121 FORUM OF JUSTICE, POMPEII")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0036#p334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122 HOUSE; POMPEII")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0037#p338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123 STROMBOLI")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0037#p340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124 VIEW OF THE ACROPOLIS, LOOKING WEST")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0037#p342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125 “HO\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0037#p344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126 THE ASSAULT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0037#p346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127 THE CARYATIDES")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0037#p348b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128 THE PARTHENON")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0037#p350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129 WE SIDLED, NOT RAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0037#p352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130 ANCIENT ACROPOLIS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0037#p353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131 RUINS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0038#p355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132 QUEEN OF GREECE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0038#p356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133 PALACE AT ATHENS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0038#p359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134 STREET SCENE IN CONSTANTINOPLE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0038#p360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135 GOOSE RANCHER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0038#p363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136 MOSQUE of ST. SOPHIA")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0038#p366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137 TURKISH MAUSOLEUM")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0039#p371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138 SLANDERED DOGS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0039#p374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139 THE CENSOR ON DUTY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0039#p378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140 TURKISH BATH")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0040#p382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141 FAR-AWAY-MOSES")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0040#p385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142 A FRAGMENT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0040#p386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143 A MEMENTO")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0042#p392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144 YALTA FROM THE EMPERORS PALACE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0042#p393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145 EMPEROR OF RUSSIA")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0042#p399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146 TINSEL KING")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0043#p404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147 SHIP EMPEROR")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0043#p405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148 THE RECEPTION")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0043#p411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149 STREET SCENE IN SMYRNA")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0044#p413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150 SMYRNA")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0044#p416",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151 AN APPARENT SUCCESS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0045#p419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152 DRIFTING TO STARBOARD")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0045#p420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153 A SPOILED NAP")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0045#p422",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154 ANCIENT AMPHITHEATER AT EPHESUS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0045#p423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155 MODERN AMPHITHEATRE AT EPHESUS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0045#p424",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156 RUINS OF EPHESUS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0045#p425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157 THE JOURNEY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0045#p429",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158 GRAVES OF THE SEVEN SLEEPERS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0046#p434",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159 THE SELECTION")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0046#p436",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160 CAMPING OUT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0046#p437",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161 ARABS’ TENTS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0047#p439",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162 A GOOD FEEDER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0047#p440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163 INTERESTING FETE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0047#p442",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164 SUNDAY SCHOOL GRAPES")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0048#p445",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165 AN OLD FOGY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0048#p446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166 RACE WITH A CAMEL")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0048#p447",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167 TEMPLE OF TILE SUN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0048#p449",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168 RUINS OF BAALBEC")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0048#p450",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169 HEWN STONES IN QUARRY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0048#p452",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170 MERCY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0048#p453",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171 PATRON SAINT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0049#p455",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172 WATER CAPRIER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0049#p457",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173 VIEW OF DAMASCUS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0049#p460",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174 STREET CARS OF DAMASCUS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0050#p466",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175 FULL DRESSED TOURIST")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0050#p474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176 IMPROMPTU HOSPITAL")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0050#p476",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177 THE HORSE “BAALBEC\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0051#p479",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178 OAR OF BASLIAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0051#p482",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179 DANGEROUS ARAB")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0051#p484",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180 GRIMES ON THE WAR-PATH")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0051#p487",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181 BEDOUIN CAMP")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0052#p489",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182 HOME OF ANCIENT POMP")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0052#p490",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183 JACK")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0052#p491",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184 A DISAPPOINTED AUDIENCE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0052#p495",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185 FIG-TREE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0052#p497",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186 “FARE TOO HIGH\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0053#p504",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187 SYRIAN HOUSE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0053#p506",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188 TIBERIAS AND SEA OF GALILEE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0054#p516",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189 THE GUARD")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0054#p521",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190 MOUNT TABOR")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0054#p524",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191 GATHERING FUEL")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0055#p530",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192 FOUNTAIN OF THE VIRGIN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0055#p531",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193 “MADONNA-LIKE BEAUTY\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0055#p533",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194 PUTNAM OUTDONE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0055#p535",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195 THE BASTINADO")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0055#p536",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196 “I WEPT\"")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0056#p539",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197 WANT OF DIGNITY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0056#p544",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198 AN ORIENTAL WELL")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0056#p545",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199 ARABS SALUTING")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0056#p546",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200 FREE SONS OF THE DESERT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0057#p552",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201 SHECHEM")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0057#p556",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202 GATE OF JERUSALEM")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0058#p559",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("203 BEGGARS IN JERUSALEM")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0058#p564",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204 CHURCH OF THE HOLY SEPULCHER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0058#p566",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205 GRAVE OF ADAM")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0059#p574",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("206 VIEW OF JERUSALEM")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0059#p577",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("207 THE WANDERING JEW")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0059#p581",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("208 MOSQUE OF OMAR")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0060#p589",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("209 AN EPIDEMIC")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0060#p590",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210 CHARGE OF BEDOUINS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0060#p594",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211 DEAD SEA")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0060#p600",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212 GROTTO OF THE NATIVITY")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0061#p606",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("213 JAFFA")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0062#p610",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214 REAR ELEVATION OF JACK")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0062#p611",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215 STREET IN ALEXANDRIA")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0062#p612",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("216 VICEROY OF EGYPT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0062#p614",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217 EASTERN MONARCH")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0062#p615",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("218 MOSES S. BEACH")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0062#p617",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("219 ROOM No. 15")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p620",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("220 THE NILOMETER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p622",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("221 ASCENT OF THE PYRAMIDS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p625",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("222 HIGH HOPES FRUSTRATED")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p626",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223 KINGS CHAMBER IN THE PYRAMID")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p627",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224 A POWERFUL ARGUMENT")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p629",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("225 PYRAMIDS AND SPHINX")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p630",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("226 THE RELIC HUNTER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p631",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227 THE MAMELUKE’S LEAP")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p633",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("228 WOULD NOT BE COMFORTED")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0063#p634",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229 THE TRAVELER")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0064#p635",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("230 HOMEWARD BOUND")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0065#p639",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231 BAD COFFEE")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0065#p640",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("232 OUR FRIENDS THE BERMUDIANS")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0065#p641",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("233 CAPTAIN DUNCAN")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0067#p651",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234 FINIS")]), _vm._v(" "), _c('br', {
    staticClass: "calibre2"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e0b4613","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0